import Container from '@/components/base/Container';
import SubscribeForm from '@/components/feature/SubscribeForm';

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="bg-background-50 py-14 md:py-20">
      <Container>
        <div className="rounded-lg border border-background-200 bg-accent-50 p-6 md:p-10">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14">
            <div>
              <p className="mb-2 flex items-center gap-2 text-xs font-label uppercase tracking-[0.22em] text-primary-600">
                <span className="h-px w-6 bg-primary-500"></span>
                Subscribe
              </p>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                订阅更新，重要节点不错过
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-[15px]">
                留下邮箱，当你在意的线索出现新进展时，我们会把最新节点整理好发给你。也可以直接在右侧补充你发现的公开来源，编辑核对后会跟进。
              </p>
              <ul className="mt-6 flex flex-col gap-3 text-sm text-foreground-700">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-secondary-600"></i>
                  只推送有明确来源的更新
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-secondary-600"></i>
                  同一线索不重复打扰
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-secondary-600"></i>
                  随时可以取消订阅
                </li>
              </ul>
            </div>
            <SubscribeForm />
          </div>
        </div>
      </Container>
    </section>
  );
}